import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {UnauthenticatedGuard} from './modules/shared/guards/unauthenticated.guard';
import {AuthenticatedGuard} from './modules/shared/guards/authenticated.guard';
import {
  UnauthenticatedWrapperComponent
} from './modules/shared/components/wrappers/unauthenticated-wrapper/unauthenticated-wrapper.component';
import {
  AuthenticatedWrapperComponent
} from './modules/shared/components/wrappers/authenticated-wrapper/authenticated-wrapper.component';
import {PageNotFoundComponent} from './modules/shared/components/page-not-found/page-not-found.component';
import {RoleGuard} from "./modules/shared/guards/role.guard";
import {DownloadExpiredComponent} from './modules/shared/components/download-expired/download-expired.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    canActivate: [UnauthenticatedGuard],
    component: UnauthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then((m) => m.AuthenticationModule),
  },
  {
    path: 'participant',
    canActivate: [AuthenticatedGuard, RoleGuard],
    component: AuthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/role-modules/participant/participant.module').then((m) => m.ParticipantModule),
  },
  {
    path: 'adult',
    canActivate: [AuthenticatedGuard, RoleGuard],
    component: AuthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/role-modules/adult/adult.module').then((m) => m.AdultModule),
  },
  {
    path: 'coach',
    canActivate: [AuthenticatedGuard, RoleGuard],
    component: AuthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/role-modules/coach/coach.module').then((m) => m.CoachModule),
  },
  {
    path: 'organization-admin',
    canActivate: [AuthenticatedGuard, RoleGuard],
    component: AuthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/role-modules/client-admin/client-admin.module').then((m) => m.ClientAdminModule),
  },
  {
    path: 'stanford-admin',
    canActivate: [AuthenticatedGuard, RoleGuard],
    component: AuthenticatedWrapperComponent,
    loadChildren: () =>
      import('./modules/role-modules/super-admin/super-admin.module').then((m) => m.SuperAdminModule),
  },
  {
    path: 'samples',
    loadChildren: () =>
      import('./modules/samples/samples.module').then((m) => m.SamplesModule),
  },
  {
    path: 'download-expired',
    component: DownloadExpiredComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
